import _ from 'lodash';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
// @mui
import { Stack } from '@mui/system';
// sections
import Header from './Header';
// reducers
import { useAppSelector, useAppDispatch } from 'hooks/redux.hooks';
import { getBeneficiaries } from 'state/reducers/beneficiary.reducers';
//components
import { Page } from 'theme/elements/Page';
import { CenteredNarrowContent } from 'theme/elements/Content';
import MobileNavbar from 'sections/layout/MobileNavbar';
import { getHistory, togglePage } from 'state/reducers/ui.reducers';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getActivity } from 'state/reducers/activity.reducers';
import { getUrlBack } from 'theme/elements/Headers';
import { Beneficiary } from 'constants/beneficiary.constants';
import Profile from './profile';
import { getPaymentById, getRefundById } from 'services/pay.services';
import { Pay } from 'constants/pay.constants';
import { title } from 'process';
import Step4 from 'sections/pay/upsert/steps/step4';

export default function RefundDetails(props: { allowActions?: boolean }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const t = useAppSelector(selectTranslations);
  //get location
  const paths = location.pathname.split('/');
  const lastPath = paths[paths.length - 1];
  const [payment, setPayment] = useState<Record<string, any> & Pay | undefined>();
  const [refund, setRefund] = useState<Record<string, any> & Pay | undefined>();
  const history = useAppSelector(getHistory);
  const urlback = getUrlBack(location.pathname, history[history.length - 1]);
  const getTotalAmount = (refund) => {
    let total = Number(refund.amount)
    if (refund?.fee) {
      total += Number(refund?.fee)
    }
    return _.isNumber(total) ? total.toFixed(2) : total
  }
  useEffect(() => {
    dispatch(getRefundById(lastPath)).then(res => {
      if (res) {
        setRefund({
          ...res,
          paymentType: _.lowerCase(res.type),
          fee: res?.fee?.amount
        })
      }
    })
  }, [lastPath]);

  console.log(refund)

  return (
    <>
      <MobileNavbar
        label={`${t('title.activity.type.paymentActivities')} ${payment?.reference}`}
        handleBack={() => {
          dispatch(togglePage(urlback));
        }}
        noCancel
      />
      {refund && (
        <Page>
          <Stack spacing={8}>
            <Header refund={{ ...refund, amount: getTotalAmount(refund) }} />
            <CenteredNarrowContent>
              <Profile refund={refund} readOnly={true} />
            </CenteredNarrowContent>
          </Stack>
        </Page>
      )}
    </>
  );
}